var map = {
	"./da-DK.json": "0dff",
	"./de-DE.json": "494b",
	"./en-GB.json": "0402",
	"./en-US.json": "a41a",
	"./fr-FR.json": "0372",
	"./it-IT.json": "7898",
	"./ja-JP.json": "28e6",
	"./ko-KR.json": "a724",
	"./ro-RO.json": "1824",
	"./sv-SE.json": "57d0",
	"./zh-CN.json": "ccd1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9e6";